import { Helmet } from "react-helmet";
import Banner from "../../../components/common/contactUs/Banner";
import ContactUsForm from "../../../components/common/contactUs/ContactUsForm";
import Header from "../../../components/common/layout/Header";
import { useTranslation } from "react-i18next";
import { useSitemap } from "../../../shared/hooks/use-sitemap";
import Canonical from "../../../components/common/layout/Canonical";
import CorporateHeader from "../../../components/common/layout/CorporateHeader";

const ContactUs = ({ type }: any) => {
    const { t } = useTranslation('common');
    useSitemap();

    return (
        <>
            <Canonical />
            <Helmet>
                <title>{t("seo_friendly.contact_us.title")}</title>
                <meta name="description" content={t("seo_friendly.contact_us.desc")} />
            </Helmet>
            <div className={`w-full h-full relative contact-us-bg ${type === "corporate" ? "mb-[30px] lg:mb-[50px]" : ""}`}>
                {type === "passenger" ? <Header type={type} /> : <CorporateHeader />}
                <Banner />

                <div className="w-full h-full container" id="home">
                    <ContactUsForm />
                </div>
            </div>
        </>
    );
};

export default ContactUs;